import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@router/router.constants";
import { isAuthenticated } from "@utils/auth.utils";

export const useLoginRedirect = () => {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  useEffect(() => {
    if (authenticated) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [authenticated, navigate]);
};
